/* eslint-disable import/no-named-as-default */
import { Button, Grid } from '@quillbot/design-system';
import React from 'react';
// import PremiumIcon from '@Common/quillElements/icon/PremiumIcon';

interface IProps {
  buttonText: string;
  onClick: Function;
  buttonIcon?: JSX.Element;
}

export function TooltipButton(props: IProps) {
  return (
    <Grid container>
      <Button
        color="primary"
        variant="contained"
        style={{
          width: '100%',
          fontWeight: 'bold',
          marginTop: '10px',
          color: 'white',
          fontSize: '12px',
          padding: '8px 18px',
        }}
        onClick={() => props.onClick()}
      >
        {/* {props.buttonIcon ? props.buttonIcon : <PremiumIcon transparent />} */}
        <span style={{ paddingLeft: '3px' }}>{props.buttonText}</span>
      </Button>
    </Grid>
  );
}

export default TooltipButton;
